<template>
	<div class="pa-6">
		<v-card>
			<v-card-title>
				Отчеты
				<v-spacer></v-spacer>
			</v-card-title>

			<a-data-table
				:headers="headers"
				api-path="logs/get_report"
				disable-sort
			>
				<template v-slot:item.time="{ item }">
					{{ item.timeFormatted }}
				</template>
				<template v-slot:item.execTime="{ item }">
					{{ item.execTime }} мс
				</template>
			</a-data-table>
		</v-card>
	</div>
</template>

<style scoped>
</style>

<script>
	import aDataTable from '../base/ADataTable.vue'

	export default {
		components: {
			aDataTable
		},
		data: () => ({
			headers: [
				{
					text: 'Время',
					value: 'time',
					align: 'center',
					noWrap: true,
					filterable: true,
					filterType: 'dateTime',
				},
				{
					text: 'Пользователь',
					value: 'userName',
					align: 'center',
					noWrap: true,
					filterable: true,
					filterType: 'select',
				},
				{
					text: 'Название',
					value: 'reportName',
					align: 'center',
					filterable: true,
					filterType: 'select',
				},
				{
					text: 'Параметры',
					value: 'parameters',
					align: 'center',
					filterable: true,
					filterType: 'text',
				},
				{
					text: 'Время формирования',
					value: 'execTime',
					align: 'center',
					noWrap: true,
					filterable: true,
					filterType: 'number',
				},
			],
		}),
		methods: {

		}
	}
</script>
